import React from 'react'
import Reflux from 'reflux'
import i18 from '../../../i18'
import BankStore from '../../../store/bankstore'
import BankHelper from '../../../helpers/bankHelper'
import BankItemRow from './pairing/BankItemRow'
import InvoiceItemRow from './pairing/InvoiceItemRow'
import api from '../../../source/api'
import NotificationSystem from 'react-notification-system'
import {Link} from "react-router-dom";

class Pairing extends Reflux.Component {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            allItemsCount: 0,
            processedItemsCount: 0,
            company_id: props.location.match.params.id,
            step: props.step,
            items: [],
            hiddenItems: [],
            assignedItems: [],
            unprocessedItems: [],
            currentIndex: null,
            bank_currency: 'HUF',
            company_currency: 'HUF',

            unpairedItems: [],
            currentItem: null,
            sum: {
                statement: 0,
                assignment: 0
            },
            company: props.company,
            buttons: {
                skippairing: true,
                savepairing: true
            },
            filterText: '',
        }

        this.store = BankStore
    }

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
        this._notificationSystem = this.refs.notificationSystem

        this.setState({
            bank_currency: this.state.bank.upload.fields.bank_exchange ? this.state.bank.upload.fields.bank_exchange.value : 'HUF',
            company_currency: this.state.bank.upload.fields.company_exchange ? this.state.bank.upload.fields.company_exchange.value : 'HUF',
        });

        let payload = {
            files: BankHelper.getFileNames(),
            vszItems: this.props.dataVszItems,
            processed: this.state.bank.upload.processed,
            unprocessed: this.state.bank.upload.unprocessed,
            statements: BankHelper.getStatements(),
            company_id: this.state.company_id
        }

        api.post('bank/pairing/init', payload)
            .then((response) => {

                this.setState({
                    items: response.data.items,
                    hiddenItems: response.data.hiddenItems,
                    assignedItems: response.data.processed,
                    unprocessedItems: response.data.unprocessed,
                    currentIndex: response.data.items.length > 0 ? 0 : null,
                });

                this.props.setBankState({
                    dataProcessed: response.data.processed,
                    dataUnprocessed: response.data.unprocessed
                });

                if (response.data.autoPairingCount > 0) {
                    this._addNotification(response.data.autoPairingCount + ' darab párosítás történt automatikusan.', 'success')
                }

            })
            .catch((err) => {
                this._addNotification('Belső hiba lépett fel, kérünk értesítse a fejlesztői csapatot. ERR-CODE-PAIRING-000', 'error');
            })
    }

    savePairingItems = () => {
        if (!this.hasSelectedBank() && !this.hasSelectedInvoice()) {
            this._addNotification('Legalább egy banki utalás és egy vevő/szállító kiválasztása kötelező. ERR-CODE-PAIRING-001', 'error')
            return
        }

        if (this.getSelectedBankItems().length > 1 && this.getSelectedInvoices().length > 1) {
            this._addNotification('Egyszerre nem lehet több tételt több számlához párosítani. ERR-CODE-PAIRING-002', 'error')
            return
        }

        let items = this.state.items;
        let pair = {
            statement: [],
            assignment: [],
        };
        let currentIndex = this.state.currentIndex;

        for (let index in items[this.state.currentIndex].statements) {
            let item = items[this.state.currentIndex].statements[index];
            if (!item.used && item.selected) {
                pair.statement.push(item.id);
                items[this.state.currentIndex].statements[index].used = true;
                items[this.state.currentIndex].statements[index].selected = false;
            }
        }

        for (let index in items[this.state.currentIndex].assignments) {
            let item = items[this.state.currentIndex].assignments[index];
            if (!item.used && item.selected) {
                pair.assignment.push(item.id);
                items[this.state.currentIndex].assignments[index].used = true;
                items[this.state.currentIndex].assignments[index].selected = false;
            }
        }

        items[this.state.currentIndex].pairs.push(pair);


        let freeStatements = items[this.state.currentIndex].statements.filter(item => !item.used).length
        let freeAssignments = items[this.state.currentIndex].assignments.filter(item => !item.used).length
        if (freeStatements === 0 || freeAssignments === 0) {

            currentIndex++;
            if (currentIndex === this.state.items.length) {
                currentIndex = null;
            }
        }

        this.setState({
            items: items,
            currentIndex: currentIndex,
            filterText: ''
        });

        this._addNotification('Párosítás mentése sikeresen megtörtént.', 'success')
    }

    nextCompanyLoad = () => {
        let currentIndex = this.state.currentIndex;

        if (currentIndex !== null) {
            currentIndex++;
            if (currentIndex === this.state.items.length) {
                currentIndex = null; // Finish the pairing
            }
        }

        this.setState({
            filterText: '',
            currentIndex: currentIndex
        });
    }

    getBankItemsRows = () => {
        let rows = [];

        if (this.state.currentIndex in this.state.items) {

            for (let index in this.state.items[this.state.currentIndex].statements) {
                let item = this.state.items[this.state.currentIndex].statements[index]

                if (item.used) {
                    continue;
                }

                if (this.state.filterText) {
                    let filterText = this.state.filterText.toLowerCase();
                    let formattedSum = new Intl.NumberFormat('hu-HU', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.sum);

                    if (item.announcement.toLowerCase().indexOf(filterText) === -1
                        && item.sum.toString().indexOf(filterText) === -1
                        && formattedSum.indexOf(filterText) === -1
                    ) {
                        continue;
                    }
                }

                rows.push(<BankItemRow
                    key={item.id + '-' + Math.random(9999, 99999)}
                    item={item}
                    selectedInvoicesSum={this.getInvoiceSum()}
                    toggleItemRow={(item, type) => this.toggleItemRow(item, type)}
                />)
            }
        }
        return rows
    }

    getInvoiceItemsRows = () => {
        let rows = []
        if (this.state.currentIndex in this.state.items) {
            let itemtype = this.state.items[this.state.currentIndex].assignments[0].type;
            for (let index in this.state.items[this.state.currentIndex].assignments) {
                let separator = false;
                let item = this.state.items[this.state.currentIndex].assignments[index];

                if (item.used) {
                    continue;
                }

                if (this.state.filterText) {
                    let filterText = this.state.filterText.toLowerCase();
                    let formattedSum = new Intl.NumberFormat('hu-HU', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.sum);

                    let certificationNumber = this.state.company.accountant_program_id === 2
                        ? item.bill_number
                        : item.certification_nb;

                    if (
                        certificationNumber.indexOf(filterText) === -1
                        && item.announcement.toLowerCase().indexOf(filterText) === -1
                        && item.sum.toString().indexOf(filterText) === -1
                        && formattedSum.indexOf(filterText) === -1
                    ) {
                        continue;
                    }
                }

                if (item.type !== itemtype && itemtype !== null && itemtype !== 'undefined') {
                    separator = true
                    itemtype = item.type
                }

                rows.push(
                    <InvoiceItemRow
                        key={item.id + '-' + Math.random(9999, 99999)}
                        item={item}
                        certification_nb={this.state.company.accountant_program_id === 2 ? item.bill_number : item.certification_nb}
                        separator={separator}
                        company={this.state.company}
                        show_currency={this.showInvoiceCurrency()}
                        show_announcement={this.state.company.accountant_program_id === 2}
                        selectedBankItems={this.getSelectedBankItems()}
                        selectedInvoiceItemsSum={this.getInvoiceSum()}
                        selectedBankItemsSum={this.getBankSum()}
                        toggleItemRow={(item, type) => this.toggleItemRow(item, type)}
                    />
                )
            }
        }
        return rows
    }

    /**
     *
     * @param {object} item
     * @param {string} type Type must be statements (for bank item) or assignments (for invoice item)
     */
    toggleItemRow(item, type) {
        let items = this.state.items;

        for (let index in items[this.state.currentIndex][type]) {
            if (items[this.state.currentIndex][type][index].id === item.id) {
                items[this.state.currentIndex][type][index].selected = !items[this.state.currentIndex][type][index].selected;
                break;
            }
        }

        this.setState({items: items});
    }

    startProcessing = () => {
        let dataUnpaired = {}
        let dataPaired = []

        let allItems = this.state.hiddenItems.concat(this.state.items);
        for (let index in allItems) {
            let items = allItems[index];

            let statements = items.statements.filter(item => !item.used);
            let assignments = items.assignments.filter(item => !item.used);

            if (statements.length > 0) {
                dataUnpaired[statements[0].company_name_formatted] = {
                    statements: statements,
                    assignments: assignments,
                };
            }

            for (let pairIndex in items.pairs) {
                dataPaired.push(items.pairs[pairIndex]);
            }
        }

        this.props.setBankState({
            dataPaired: dataPaired,
            dataUnpaired: dataUnpaired
        });

        this.props.setNextStep();

        this._addNotification('Kimeneti fájl generelása folyamatban, kérjük várjon...', 'success')
    }

    onFilterChange = (event) => {
        this.setState({filterText: event.target.value});
    }

    clearFilter = () => {
        this.setState({filterText: ''});
    }

    /**
     * @returns {*[]}
     */
    getSelectedBankItems = () => {
        let items = [];
        for (let index in this.state.items[this.state.currentIndex].statements) {
            let item = this.state.items[this.state.currentIndex].statements[index];
            if (!item.used && item.selected) {
                items.push(item);
            }
        }
        return items;
    }

    /**
     * @returns {*[]}
     */
    getSelectedInvoices = () => {
        let items = [];
        for (let index in this.state.items[this.state.currentIndex].assignments) {
            let item = this.state.items[this.state.currentIndex].assignments[index];
            if (!item.used && item.selected) {
                items.push(item);
            }
        }
        return items;
    }

    /**
     * @returns {boolean}
     */
    hasSelectedBank = () => {
        return this.getSelectedBankItems().length > 0;
    }

    /**
     * @returns {boolean}
     */
    hasSelectedInvoice = () => {
        return this.getSelectedInvoices().length > 0;
    }

    /**
     * @returns {boolean}
     */
    hasSelectedBankOrInvoice = () => {
        return this.hasSelectedBank() || this.hasSelectedInvoice();
    }

    hasExchange = () => {
        return this.state.bank_currency !== this.state.company_currency;
    }

    getCompareCurrency = () => {
        if (!this.hasExchange()) {
            return this.state.bank_currency;
        }

        return this.state.bank_currency !== 'HUF' ? this.state.bank_currency : this.state.company_currency
    }

    getBankSum = () => {
        let sum = 0;
        for (let index in this.state.items[this.state.currentIndex].statements) {
            let item = this.state.items[this.state.currentIndex].statements[index];
            if (!item.used && item.selected) {
                sum += item.sum;
            }
        }
        return sum;
    }

    getInvoiceSum = () => {
        let sum = 0;
        for (let index in this.state.items[this.state.currentIndex].assignments) {
            let item = this.state.items[this.state.currentIndex].assignments[index];
            if (!item.used && item.selected) {
                let isBuyer = item.book_keeping_number.substr(0, 1) !== '4';

                // todo: Ellenőrizni RLB-ben a devizás számolásokat
                if (this.state.company.accountant_program_id === 1 && item.origin_currency !== 'HUF') {
                    sum += item.origin_sum * (isBuyer ? 1 : -1);
                } else {
                    sum += item.sum * (isBuyer ? 1 : -1);
                }
            }
        }
        return sum;
    }

    sumDifference = () => {
        return this.getBankSum() - this.getInvoiceSum();
    }

    isSumEqual = () => {
        return this.sumDifference() === 0;
    }

    formatPrice = (sum, currency) => {
        currency = currency || 'HUF';
        return new Intl.NumberFormat('hu-HU', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(sum) + ' ' + currency;
    }

    showInvoiceCurrency = () => {
        for (let index in this.state.items[this.state.currentIndex].assignments) {
            let item = this.state.items[this.state.currentIndex].assignments[index];
            if (item.origin_currency !== 'HUF') {
                return true;
            }
        }
        return false;
    }

    onRemovePair = (index) => {

        let items = this.state.items;
        let pair = items[this.state.currentIndex].pairs[index];

        for (let bankIndex in items[this.state.currentIndex].statements) {
            let item = items[this.state.currentIndex].statements[bankIndex];
            if (pair.statement.includes(item.id)) {
                items[this.state.currentIndex].statements[bankIndex].used = false;
            }
        }

        for (let invoiceIndex in items[this.state.currentIndex].assignments) {
            let item = items[this.state.currentIndex].assignments[invoiceIndex];
            if (pair.assignment.includes(item.id)) {
                items[this.state.currentIndex].assignments[invoiceIndex].used = false;
            }
        }

        items[this.state.currentIndex].pairs.splice(index, 1);

        this.setState({items: items});

        this._addNotification('A párosítást sikeresen visszavontad', 'success');
    }

    renderPairs = () => {
        let pairs = [];
        for (let index in this.state.items[this.state.currentIndex].pairs) {
            let pair = this.state.items[this.state.currentIndex].pairs[index];
            let bankSum = 0;

            for (let bankIndex in this.state.items[this.state.currentIndex].statements) {
                let item = this.state.items[this.state.currentIndex].statements[bankIndex];
                if (pair.statement.includes(item.id)) {
                    bankSum += item.sum;
                }

            }

            bankSum = this.formatPrice(bankSum, this.state.bank_currency);
            pairs.push(
                <span className="border border-success text-success rounded-pill px-2 d-inline-block mr-1" key={index + '-' + Math.random(9999, 99999)}>
                    {bankSum}
                    <button type="button" className="close ml-1" aria-label="Close" onClick={() => this.onRemovePair(index)}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </span>
            );
        }
        return pairs;
    }

    prevCompany = () => {
        if (this.state.items.length === 0) {
            return;
        }

        if (this.state.currentIndex === 0) {
            return;
        }

        this.setState({
            currentIndex: (this.state.currentIndex === null ? this.state.items.length : this.state.currentIndex) - 1
        })
    }

    nextCompany = () => {
        if (this.state.items.length === 0) {
            return;
        }

        if (this.state.currentIndex === null) {
            return;
        }

        if (this.state.currentIndex + 1 >= this.state.items.length) {
            this.setState({
                currentIndex: null
            })
            return;
        }

        this.setState({
            currentIndex: this.state.currentIndex + 1
        })
    }

    render() {
        return (
            <section id='pairing'>
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-md-12'>
                            <ul className='legend no-list-style-type pl-0'>
                                <li>
                                    <h4 className='text-left'>Kiválasztott cég: {this.state.bank.upload.company ? this.state.bank.upload.company.name : ''} (<Link className='link-color' to='/'>cég csere</Link>)</h4>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-4">
                            <div>
                                <a className={"btn btn-link" + (this.state.currentIndex !== 0 ? '' : ' invisible')}
                                   type="button"
                                   onClick={() => this.prevCompany()}>Előző</a>
                                <span>[ {this.state.currentIndex === null ? this.state.items.length : this.state.currentIndex} / {this.state.items.length} ]</span>
                                <a className={"btn btn-link" + (this.state.currentIndex !== null ? '' : ' invisible')}
                                   type="button"
                                   onClick={() => this.nextCompany()}>Következő</a>
                            </div>
                        </div>

                        {this.state.currentIndex !== null
                            ? <div className="col-4 text-center">
                                <h2>{this.state.items[this.state.currentIndex].assignments[0].company}</h2>
                            </div>
                            : ''}

                        {this.state.currentIndex !== null
                            ? <div className='col-md-4'>
                                <div className='pull-right'>
                                    <div className='input-group'>
                                        <input
                                            type='text'
                                            className='form-control'
                                            spellCheck='false'
                                            autoComplete='off'
                                            id='filterText'
                                            name='filterText'
                                            value={this.state.filterText}
                                            onKeyUp={this.onFilterChange}
                                            onChange={this.onFilterChange}
                                        />
                                        <div className='input-group-append'>
                                            <button
                                                className='btn btn-outline-secondary'
                                                type='button'
                                                onClick={this.clearFilter}
                                            >
                                                <i className='fa fa-times' aria-hidden='true'/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ''}
                    </div>
                    {this.state.currentIndex === null
                        ? <div className='col-md-12'>
                            <h5 className='text-center margin-top-150'>
                                Kérjük lépjen tovább a feldolgozáshoz, nyomja meg a lenti gombot.
                            </h5>
                        </div>
                        : ''
                    }
                </div>

                {this.state.currentIndex !== null
                    ? <div>
                        <div className={!this.state.buttons.savepairing ? 'd-none' : 'row'}>
                            <div className="col-md-6">
                                <div className='sticky'>
                                    <div className="py-2">
                                        <div className='container text-center my-2'>
                                            <a onClick={() => this.savePairingItems()} className={!this.state.buttons.savepairing ? 'd-none' : 'choose-btn'}>{i18.BUTTONS._savePairing}</a>&nbsp;&nbsp;
                                            <a onClick={() => this.nextCompanyLoad()} className={!this.state.buttons.skippairing ? 'd-none' : 'choose-btn-no-bg'}>{i18.BUTTONS._skipPairing}</a>
                                        </div>
                                        <table className="table table-striped table-hover table-aibook-no-border m-0">
                                            <thead>
                                            <tr>
                                                <th>{i18.BANK._partner}</th>
                                                <th>{i18.BANK._date}</th>
                                                <th>{i18.BANK._sum}</th>
                                                <th>{i18.BANK._announcement}</th>
                                            </tr>
                                            <tr className={(this.hasSelectedBankOrInvoice() ? (this.isSumEqual() ? 'table-success' : 'table-warning') : '') + ' result'}>
                                                <td colSpan='4'>
                                                    {i18.BANK._selectedTransfersSum}
                                                    <span style={{float: 'right'}}>
													{this.formatPrice(this.getBankSum(), this.getCompareCurrency())}
                                                        {this.isSumEqual()
                                                            ? ''
                                                            : <span style={{color: "red", fontWeight: "bold", marginLeft: "10px"}}>
															{this.formatPrice(Math.abs(this.sumDifference()), this.getCompareCurrency())}
														</span>
                                                        }
                                                </span>
                                                </td>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.getBankItemsRows()}
                                            </tbody>
                                            <tfoot>
                                            <tr className={(this.hasSelectedBankOrInvoice() ? (this.isSumEqual() ? 'table-success' : 'table-warning') : '') + ' result'}>
                                                <td colSpan='4'>
                                                    {i18.BANK._selectedTransfersSum}
                                                    <span style={{float: 'right'}}>
													{this.formatPrice(this.getBankSum(), this.getCompareCurrency())}
                                                        {this.isSumEqual()
                                                            ? ''
                                                            : <span style={{color: "red", fontWeight: "bold", marginLeft: "10px"}}>
															{this.formatPrice(Math.abs(this.sumDifference()), this.getCompareCurrency())}
														</span>
                                                        }
                                                </span>
                                                </td>
                                            </tr>
                                            </tfoot>
                                        </table>
                                        <div className='container text-center my-2'>
                                            <a onClick={() => this.savePairingItems()} className={!this.state.buttons.savepairing ? 'd-none' : 'choose-btn'}>{i18.BUTTONS._savePairing}</a>&nbsp;&nbsp;
                                            <a onClick={() => this.nextCompanyLoad()} className={!this.state.buttons.skippairing ? 'd-none' : 'choose-btn-no-bg'}>{i18.BUTTONS._skipPairing}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='sticky'>
                                    <div className="py-2">
                                        <div className='container text-center my-2'>
                                            <a onClick={() => this.savePairingItems()} className={!this.state.buttons.savepairing ? 'd-none' : 'choose-btn'}>{i18.BUTTONS._savePairing}</a>&nbsp;&nbsp;
                                            <a onClick={() => this.nextCompanyLoad()} className={!this.state.buttons.skippairing ? 'd-none' : 'choose-btn-no-bg'}>{i18.BUTTONS._skipPairing}</a>
                                        </div>
                                        <table className="table table-striped table-hover table-aibook-no-border m-0">
                                            <thead>
                                            <tr>
                                                <th>{i18.BANK._mainBookNumber}</th>
                                                <th>{i18.BANK._date}</th>
                                                <th className={this.showInvoiceCurrency() ? '' : 'd-none'}>Devizás ár</th>
                                                <th>{i18.BANK._sum}</th>
                                                <th>{i18.BANK._voucherNumber}</th>
                                                <th className={this.state.company.accountant_program_id === 2 ? '' : 'd-none'}>Nyugta szöveg</th>
                                            </tr>
                                            <tr className={(this.hasSelectedBankOrInvoice() ? (this.isSumEqual() ? 'table-success' : 'table-warning') : '') + ' result'}>
                                                <td colSpan={4 + (this.showInvoiceCurrency() ? 1 : 0) + (this.state.company.accountant_program_id === 2 ? 1 : 0)}>
                                                    {i18.BANK._selectedInvoicesSum}
                                                    <span className='float-right'>
													{this.formatPrice(this.getInvoiceSum(), this.getCompareCurrency())}
                                                        {this.hasExchange() || this.isSumEqual()
                                                            ? ''
                                                            : <span style={{color: "red", fontWeight: "bold", marginLeft: "10px"}}>
															{this.formatPrice(this.sumDifference(), this.getCompareCurrency())}
														</span>
                                                        }
												</span>
                                                </td>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.getInvoiceItemsRows()}
                                            </tbody>
                                            <tfoot>
                                            <tr className={(this.hasSelectedBankOrInvoice() ? (this.isSumEqual() ? 'table-success' : 'table-warning') : '') + ' result'}>
                                                <td colSpan={5 + (this.showInvoiceCurrency() ? 1 : 0) + (this.state.company.accountant_program_id === 2 ? 1 : 0)}>
                                                    {i18.BANK._selectedInvoicesSum}
                                                    <span className='float-right'>
													{this.formatPrice(this.getInvoiceSum(), this.getCompareCurrency())}
                                                        {this.hasExchange() || this.isSumEqual()
                                                            ? ''
                                                            : <span style={{color: "red", fontWeight: "bold", marginLeft: "10px"}}>
															{this.formatPrice(this.sumDifference(), this.getCompareCurrency())}
														</span>
                                                        }
												</span>
                                                </td>
                                            </tr>
                                            </tfoot>
                                        </table>
                                        <div className='container text-center my-2'>
                                            <a onClick={() => this.savePairingItems()} className={!this.state.buttons.savepairing ? 'd-none' : 'choose-btn'}>{i18.BUTTONS._savePairing}</a>&nbsp;&nbsp;
                                            <a onClick={() => this.nextCompanyLoad()} className={!this.state.buttons.skippairing ? 'd-none' : 'choose-btn-no-bg'}>{i18.BUTTONS._skipPairing}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                {this.renderPairs()}
                            </div>
                        </div>
                    </div>
                    : null
                }

                <div className="col-md-12 text-center mt-5">
                    <a onClick={(event) => this.startProcessing(event)} className="choose-btn">{i18.BUTTONS._startProcessing}</a>
                </div>

                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default Pairing


// WEBPACK FOOTER //
// ./src/components/bank/steps/Pairing.js